import { createRoutine } from 'redux-saga-routines'
import { call, put, takeLatest, fork, select } from '@redux-saga/core/effects'
import * as tutorialsService from 'services/tutorialsService'
import { toast } from 'react-toastify'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'

export const fetchTutorialsRoutine = createRoutine('TUTORIALS/FETCH_ALL')

// Tutorials are content-managed and rarely change — cache the response for
// 5 minutes so the 3+ call sites (Navigation, WhatsNewModal, TutorialsPanel)
// don't keep re-hitting the API on every mount. Pass `{ force: true }` to bypass.
const TUTORIALS_TTL_MS = 5 * 60 * 1000

function* fetchTutorials({ payload } = {}) {
  if (!payload?.force) {
    const lastFetchedAt = yield select(s => s.tutorials?.lastFetchedAt || 0)
    const items = yield select(s => s.tutorials?.items || [])
    if (items.length > 0 && Date.now() - lastFetchedAt < TUTORIALS_TTL_MS) {
      return
    }
  }

  yield put(fetchTutorialsRoutine.request())
  try {
    const { data } = yield call(tutorialsService.fetchTutorials)
    yield put(fetchTutorialsRoutine.success(data))
  } catch (error) {
    if (checkIsOnline()) {
      console.error('Error fetching tutorials', error)
      toast.error('Failed to load tutorials')
    }
    yield put(fetchTutorialsRoutine.failure(error))
  }
}

export function* fetchTutorialsWatcher() {
  yield takeLatest(fetchTutorialsRoutine.TRIGGER, fetchTutorials)
}

export const tutorialsSagas = [
  fork(fetchTutorialsWatcher)
]
